import jsPDF from 'jspdf';
import {
  exportDataGrid,
} from 'devextreme-react/common/export/pdf';
import { base64HeaderImage } from 'components/ReportGrid/constants';
import dayjs from 'dayjs';
import { CustomizeCellOptions, PDFExportProps } from '../types';
import { theme } from 'core/Theming/theme';

export const exportToPDF = ({
  e,
  title,
  headerTitleForSheet,
  reportHeaderTagLine,
  pdfOrientation = 'portrait',
}: PDFExportProps) => {
  const doc = new jsPDF({ orientation: pdfOrientation });

  doc.addImage(base64HeaderImage, 'png', 10, 15, 45, 10);
  doc.setFont('Times', undefined, 'bold').setFontSize(18);
  doc.text(headerTitleForSheet ?? 'Report', 70, 25);
  doc.setFontSize(14);
  doc.text(reportHeaderTagLine ?? '', 10, 35, { maxWidth: 280 });

  exportDataGrid({
    jsPDFDocument: doc,
    component: e.component,
    margin: { top: 50, left: 10, right: 10, bottom: 10 },
    customizeCell: ({ gridCell, pdfCell }: CustomizeCellOptions) => {
      if (pdfCell) {
        pdfCell.wordWrapEnabled = true;
        pdfCell.padding = { top: 2, bottom: 2, left: 1, right: 1 };
        pdfCell.textColor = theme.palette.primary.dark;
      }

      if (gridCell?.rowType === 'header' && pdfCell) {
        pdfCell.font = { style: 'bold' };
        pdfCell.borderColor = '#f5f5f5';
        pdfCell.backgroundColor = '#f5f5f5';
      }

      if ((gridCell?.rowType === 'data' || gridCell?.rowType === 'totalFooter') && pdfCell) {
        pdfCell.borderColor = theme.palette.background.default;
      }

    },
  }).then(() => {
    doc.save(`${title + dayjs().format('DDMMYYYY')}.pdf`);
  });
};
